import { Box, Stack, Text } from "@mantine/core";
import { HelpIcon } from "@dehub/theme";
import type { ReactNode } from "react";
import classes from "./detail-card.module.css";

/**
 * White card: radius lg, slate hairline border, soft shadow, 17px title (canvas Ord_ReturnDetail, Ord_Rules O43).
 * `helpKey` adds the section «?» after the title (@dehub/help `section`).
 */
export function DetailCard ({ title, extra, helpKey, children }: { title?: ReactNode; extra?: ReactNode; helpKey?: string; children: ReactNode }){
  return (
    <Box className={classes.card} component="section">
      {title || extra ? (
        <Box className={classes.head}>
          {title ? (
            <Text className={classes.title}>
              {title}
              {helpKey ? <HelpIcon helpKey={helpKey} variant="section" /> : null}
            </Text>
          ) : <Box />}
          {extra}
        </Box>
      ) : null}
      {children}
    </Box>
  );
}

/** Label above value. Empty value = «-». */
export function Field ({ label, value, mono }: { label: ReactNode; value?: ReactNode; mono?: boolean }){
  const empty = value == null || value === "";
  return (
    <Stack gap={2}>
      <Text className={classes.label}>{label}</Text>
      <Box className={classes.value} data-mono={mono || undefined} translate={mono ? "no" : undefined}>
        {empty ? "-" : value}
      </Box>
    </Stack>
  );
}

/** Label left, value right, hairline between rows (side cards). */
export function SideRow ({ label, value, mono }: { label: ReactNode; value?: ReactNode; mono?: boolean }){
  const empty = value == null || value === "";
  return (
    <Box className={classes.row}>
      <Text className={classes.label}>{label}</Text>
      <Box className={classes.value} data-mono={mono || undefined} ta="right">
        {empty ? "-" : value}
      </Box>
    </Box>
  );
}
